<template>
  <b-container>
    <LoadingIndicator 
      v-if="loading"
    />
    <div v-if="!loading">
      <b-row>
        <b-col></b-col>
        <b-col cols="6">
          <h2>Settings</h2>
          <BaseMessageBlock type="Success" :messages="messages"></BaseMessageBlock>
          <b-form @submit.prevent="saveSettings">
            <b-form-group label="Name"
              label-for="Name"
              invalid-feedback="Please enter your name">
              <b-form-input
                id="user-name"
                v-model.trim="form.name"
                required
                maxlength="100"
                :state="errors.length == 0 ? null : form.name.length > 0">
              </b-form-input>
            </b-form-group>
            <b-form-group label="Mobile Phone"
              label-for="phone"
              invalid-feedback="Please enter a valid phone number">
              <b-form-input
                id="user-phone"
                v-model="form.phone"
                required
                type="tel"
                :state="errors.length == 0 ? null : validPhone"
                v-mask="'(###) ###-####'">
              </b-form-input>
            </b-form-group>
            <b-form-group label="Allow Email notifications"
              label-for="email-notify">
              <b-form-select id="email-notify"
                v-model="form.emailNotifications"
                :state="errors.length == 0 ? null : true">
                  <b-form-select-option :value="true">Yes</b-form-select-option>
                  <b-form-select-option :value="false">No</b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group label="Allow Text notifications"
              label-for="text-notify">
              <b-form-select id="text-notify"
                v-model="form.textNotifications"
                invalid-feedback="Please enter a valid phone number"
                :state="errors.length == 0 ? null : validTextNotifications">
                  <b-form-select-option :value="true">Yes</b-form-select-option>
                  <b-form-select-option :value="false">No</b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-row>
              <b-col>
                  <b-button
                    class="mr-3"
                    type="submit"
                    variant="primary"
                    :disabled="sending"
                  >
                    <div v-if="!sending">Save</div>
                    <div v-else>
                      <b-spinner small label="Spinning"></b-spinner>
                    </div>
                  </b-button>
                  <b-button @click="revertChanges">Cancel</b-button>
              </b-col>
            </b-row>
          </b-form>
          <b-row>
            <b-col>
              <BaseMessageBlock :messages="errors"></BaseMessageBlock>
              <!-- <BaseMessageBlock :type="'Success'" :messages="messages"></BaseMessageBlock> -->
            </b-col>
          </b-row>
        </b-col>
        <b-col></b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";

export default {
  name: "Settings",
  data() {
    return {
      loading: false,
      sending: false,
      errors: [],
      messages: [],
      form: {
        name: '',
        phone: '',
        emailNotifications: false,
        textNotifications: false
      },
      settings: null
    }
  },
  mounted() {
    let id = this.accountUser.userId;

    //Attempt to get user summary
    this.loading = true;
    axios
      .get(`${this.$api_url}/users/${id}/settings`, this.getReqConfig())
      .then(response => {
        this.setup(response.data);

      })
      .catch((err) => {
        this.errors.push(...this.$helpers.formatErrors(err));
      })
      .finally(() => {
        this.loading = false;
      });

    if (this.$route.query.setup == 'true') {
      this.messages.push({ message: "You're all set!"});
      this.messages.push({ message: "Be on the lookout for your monthly project surveys."});
      this.messages.push({ message: '<a href="https://support.microsoft.com/en-ie/office/add-recipients-of-my-email-messages-to-the-safe-senders-list-be1baea0-beab-4a30-b968-9004332336ce">For best results, add info@dashtech.app to your safe senders list.</a>'});
    }
  },
  methods: {
    setup(settings) {
      this.settings = settings;
      this.form = this.newForm(settings);
      
    },
    newForm(settings) {
      return {
        name: settings.user.name,
        phone: settings.user.phone,
        emailNotifications: settings.emailNotifications,
        textNotifications: settings.textNotifications
      };
    },
    revertChanges() {
      this.form = this.newForm(this.settings);
      this.errors = [];
    },
    saveSettings() {
      if (!this.validateForm(this.form)) {
        return;
      }

      this.sending = true;
      let request = {
        user: {
          ...this.settings.user,
          phone: this.form.phone
        },
        emailNotifications: this.form.emailNotifications,
        textNotifications: this.form.textNotifications
      };

      axios
        .post(`${this.$api_url}/users/${request.user.userId}/settings/update`,
          request, this.getReqConfig())
        .then(() => {
          this.$router.go();
        })
        .catch((err) => {
          this.errors.push(...this.$helpers.formatErrors(err));
          this.sending = false;
        });
    },
    validateForm(form) {
      let errorCount = this.errors.length;

      if (this.form.name.length === 0) {
        this.errors.push({ message: "Name is empty"});
      }
      if (!form.textNotifications && !form.emailNotifications) {
        this.errors.push({ message: "At least one notification method must be enabled"});
      }
      if (this.validPhone === false) {
        this.errors.push({ message: "Phone number is invalid" });
      }

      return errorCount == this.errors.length;
    }
  },
  computed: {
    validPhone() {
      return this.form.phone
        ? this.form.phone.replace(/[^0-9]/g, '').length === 10
        : false
    },
    validTextNotifications() {
      return this.form.textNotifications
        ? this.validPhone
        : true
    },
  }
}
</script>